import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const subscribeNewsletter = (email) =>
  api.post("/newsletter", { email }).then((r) => r.data);

export const submitApplication = (payload) =>
  api.post("/applications", payload).then((r) => r.data);

export const submitSchoolInquiry = (payload) =>
  api.post("/school-inquiries", payload).then((r) => r.data);

export const submitBrandInquiry = (payload) =>
  api.post("/brand-inquiries", payload).then((r) => r.data);

export const submitInterest = (payload) =>
  api.post("/interest", payload).then((r) => r.data);

export const getDocuments = () => api.get("/documents").then((r) => r.data);

// ---- Admin ----
const TOKEN_KEY = "blv_admin_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => localStorage.setItem(TOKEN_KEY, t);
export const clearToken = () => localStorage.removeItem(TOKEN_KEY);
const auth = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

export const adminLogin = (email, password) =>
  api.post("/auth/login", { email, password }).then((r) => r.data);
export const adminMe = () => api.get("/auth/me", auth()).then((r) => r.data);
export const adminSummary = () => api.get("/admin/summary", auth()).then((r) => r.data);
export const adminList = (kind, params = {}) =>
  api.get(`/admin/${kind}`, { ...auth(), params }).then((r) => r.data);
export const adminStatus = (kind, id, payload) =>
  api.patch(`/admin/${kind}/${id}/status`, payload, auth()).then((r) => r.data);
export const adminRecord = (kind, id) =>
  api.get(`/admin/${kind}/${id}`, auth()).then((r) => r.data);
export const adminUpdateInvitation = (applicationId, payload) =>
  api.patch(`/admin/participants/${applicationId}/invitation`, payload, auth()).then((r) => r.data);
export const adminResendInvitation = (applicationId) =>
  api.post(`/admin/participants/${applicationId}/resend-invitation`, {}, auth()).then((r) => r.data);
export const adminRoster = () =>
  api.get("/admin/roster", auth()).then((r) => r.data);
export const getCohortMembers = () =>
  api.get("/cohort/members").then((r) => r.data);

export const getPartners = () => api.get("/partners").then((r) => r.data);
export const adminPartners = () => api.get("/admin/partners", auth()).then((r) => r.data);
export const adminCreatePartner = (payload) => api.post("/admin/partners", payload, auth()).then((r) => r.data);
export const adminUpdatePartner = (id, payload) => api.patch(`/admin/partners/${id}`, payload, auth()).then((r) => r.data);
export const adminDeletePartner = (id) => api.delete(`/admin/partners/${id}`, auth()).then((r) => r.data);
export const adminBroadcasts = () => api.get("/admin/broadcasts", auth()).then((r) => r.data);
export const adminSendCountdownTeaser = () => api.post("/admin/broadcasts/countdown-teaser", {}, auth()).then((r) => r.data);
export const adminSendOpeningBlast = () => api.post("/admin/broadcasts/opening-blast", {}, auth()).then((r) => r.data);
export const newsletterCount = () => api.get("/newsletter/count").then((r) => r.data);
export const adminAnalytics = () => api.get("/admin/analytics", auth()).then((r) => r.data);
export const getOrgSettings = () => api.get("/org-settings").then((r) => r.data);
export const adminUpdateOrgSettings = (payload) => api.patch("/admin/org-settings", payload, auth()).then((r) => r.data);
export const submitContact = (payload) => api.post("/contact", payload).then((r) => r.data);
export const adminContactMessages = () => api.get("/admin/contact-messages", auth()).then((r) => r.data);
export const adminReview = (kind, id, payload) =>
  api.put(`/admin/${kind}/${id}/review`, payload, auth()).then((r) => r.data);
export const adminEmailLog = (id) =>
  api.get(`/admin/email-log/${id}`, auth()).then((r) => r.data);

// ---- Onboarding ----
export const getOnboarding = (token) =>
  api.get(`/onboarding/${token}`).then((r) => r.data);
export const saveOnboardingSection = (token, section, data) =>
  api.put(`/onboarding/${token}`, { section, data }).then((r) => r.data);
export const submitAgreements = (token, acknowledgments) =>
  api.post(`/onboarding/${token}/agreements`, { acknowledgments }).then((r) => r.data);
export const completeOnboarding = (token) =>
  api.post(`/onboarding/${token}/complete`).then((r) => r.data);

export const getAcceptance = (token) =>
  api.get(`/acceptance/${token}`).then((r) => r.data);
export const acceptPlace = (token) =>
  api.post(`/acceptance/${token}/accept`).then((r) => r.data);

export const errText = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ");
  return "Something went wrong. Please try again.";
};
